$(function() {
    $(document).on("click", ".tile", function() {
        window.location.href = $(this).attr('data-href');
    });
});
